const config = {
  name: "breck",
  features: {
    accessCodes: false,
    moreInformation: true,
    hasParkingInstructions: true,
    hasPromoCodeWarning: false,
    displayPromoTotalUses: true, // Display "Redemptions left" on promo code card
    mandatoryFields: true,
    userPhoneNumber: true,
    showAdaSupport: true,
    userName: true,
    userPostalCode: true
  },
  parkingSession: {
    // At midnight on the day of parking
    cancelDaysBefore: 0,
    cancelTime: "08:00",
    cancelTimeOptions: [],
    // Start time offset from midnight, i.e. 6 am
    startOffsetHrs: 6,
    // Start date offset from today (0 = today)
    startOffsetDate: 1,
    // End date offset from start time
    endOffsetDate: 160
  }
}
export default config
